/**
 * Traçage des consultations (clic sur un devis, une facture, un document).
 * Envoi « fire & forget » : n'interrompt jamais le parcours utilisateur.
 * Les actions sont validées côté serveur (liste blanche).
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackView = (action, { resourceType, resourceId, details } = {}) => {
  axios
    .post(
      `${API}/logs/track`,
      { action, resourceType, resourceId, details },
      { headers: { Authorization: 'Bearer cookie-auth' } }
    )
    .catch(() => {});
};

export default trackView;
